import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { IStageStatusPair, getBusinessUnitsByUserId } from 'wisestep-api';
import { WsSelect, WsSelectObj } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';
export interface WsSelectBusinessDefinition {
  label: string;
  value: IStageStatusPair[];
}
const JobListingBusinessUnitFilter = ({ name }: WsFilterProps) => {
  const [dropDownOption, setDropDownOption] = useState<WsSelectObj[]>();

  const defaultOptions: WsSelectObj[] = [
    {
      label: 'All',
      value: 'AlllabelAll',
    },
  ];
  const methods = useForm();
  const fetchAllBusinessDefinition = useCallback(async () => {
    const response = await getBusinessUnitsByUserId();
    if (response.data.length > 0) {
      const newOptions = response.data.map((element) => {
        return {
          label: element.name,
          value: element.id + 'label' + element.name,
        };
      });
      setDropDownOption([...defaultOptions, ...newOptions]);
    }

    methods.reset();
  }, [methods]);

  useEffect(() => {
    fetchAllBusinessDefinition();
  }, [fetchAllBusinessDefinition]);

  return (
    <WsAccordion title="Business Unit">
      <WsSelect
        name={name}
        selectArray={dropDownOption ?? defaultOptions}
        placeholder={
          dropDownOption
            ? 'Business Unit'
            : '--No Business Unit Available. Please Configure from Settings Page--'
        }
        disabled={dropDownOption ? false : true}
      />
    </WsAccordion>
  );
};

export default JobListingBusinessUnitFilter;
